import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi';
import { getAccount, writeContract, readContract, waitForTransaction, disconnect, watchAccount, switchNetwork, getNetwork } from '@wagmi/core';
import { bsc } from '@wagmi/core/chains';
import Swal from 'sweetalert2';

// Manipulando el DOM
const btnE2 = document.getElementById('btn2');
const userEl = document.getElementById('user');
const bnb = document.getElementById('bnb-price');
const tokenCost = document.getElementById('token-cost');
const valueInBnb = document.getElementById('value-in-bnb');
const visibleBlock = document.querySelector('.visible-block');
const invisibleBlock = document.querySelector('.invisible-block');

const visibleBlock2 = document.querySelector('.visible-block2');
const invisibleBlock2 = document.querySelector('.invisible-block2');
const invisibleBlock3 = document.querySelector('.invisible-block3');

const btnBuy = document.getElementById('buy');
const btnVote = document.getElementById('vote');
const btnViewResult = document.getElementById('view_result');

const option1 = document.getElementById('option1');
const option2 = document.getElementById('option2');
const image_cat = document.getElementById('image-cat').getAttribute('src');

var address_user = '';
var option;
const votingId = 1;

// 1. Define constants
//const projectId =  import.meta.env.VITE_PROJECT_ID;
const projectId = "caf3c8951c3c58aac1ca5cfb1aff9c63";
const smartContract = "0xcd0fc905b27ce2d22f49720965f27722d5108ee8";
const wagmigotchiABI = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"votingId","type":"uint256"},{"indexed":false,"internalType":"string","name":"name","type":"string"}],"name":"OptionAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"votingId","type":"uint256"},{"indexed":false,"internalType":"string","name":"name","type":"string"}],"name":"OptionRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"votingId","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"string","name":"optionName","type":"string"}],"name":"VoteCasted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"votingId","type":"uint256"},{"indexed":false,"internalType":"string","name":"title","type":"string"}],"name":"VotingCreated","type":"event"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"_hasNFT","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"votingId","type":"uint256"},{"internalType":"string","name":"name","type":"string"}],"name":"addOption","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"}],"name":"checkBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"contractURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"usdAmount","type":"uint256"}],"name":"convertToBNBWei","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"title","type":"string"}],"name":"createVoting","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"votingId","type":"uint256"}],"name":"endVoting","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getAllVotings","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"},{"internalType":"string[]","name":"","type":"string[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getLatestPrice","outputs":[{"internalType":"int256","name":"","type":"int256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getLatestPriceBNB","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"getTokenIdByOwner","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"votingId","type":"uint256"}],"name":"getVotingResult","outputs":[{"internalType":"string[]","name":"optionNames","type":"string[]"},{"internalType":"uint256[]","name":"optionVotes","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"votingId","type":"uint256"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"hasTokenVoted","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"mintNFT","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"nftPriceInUSD","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"paymentWallet","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"votingId","type":"uint256"},{"internalType":"string","name":"name","type":"string"}],"name":"removeOption","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"URI","type":"string"}],"name":"setBaseURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"URI","type":"string"}],"name":"setContractURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"priceInUSD","type":"uint256"}],"name":"setNFTPrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_paymentWallet","type":"address"}],"name":"setPaymentWallet","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"unpause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"votingId","type":"uint256"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"string","name":"optionName","type":"string"}],"name":"vote","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"votings","outputs":[{"internalType":"string","name":"title","type":"string"},{"internalType":"bool","name":"exists","type":"bool"},{"internalType":"bool","name":"isActive","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"contract IERC20","name":"token","type":"address"}],"name":"withdrawERC20","outputs":[],"stateMutability":"nonpayable","type":"function"},{"stateMutability":"payable","type":"receive"}];

// 2. Create wagmiConfig
const metadata = {
  name: 'Voting Criptosolucion',
  description: 'Voting Criptosolucion',
  url: 'https://voting.criptosolucion.com/',
  icons: ["https://criptosolucion.com/images/proyectos/gateway.webp"]
}

// Cadena de BSC testnet
const chains = [bsc]
const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata })

// 3. Create modal
const modal = createWeb3Modal({ wagmiConfig, projectId, chains })

// Eventos
btnE2.addEventListener('click', connect)
btnBuy.addEventListener('click', buyVoto)
btnVote.addEventListener('click', vote)
btnViewResult.addEventListener('click', view_results)
option1.addEventListener('click', select_option)
option2.addEventListener('click', select_option)

document.addEventListener('DOMContentLoaded', function () {
  const voteOptions = document.querySelectorAll('.vote-option');

  voteOptions.forEach(option => {
    option.addEventListener('click', function () {
      voteOptions.forEach(opt => opt.classList.remove('selected'));
      this.classList.add('selected');
    });
  });
});

function connect() {
  if (getAccount().isConnected) {
    disconnect();
    cleanResults();
  } else {
    modal.open()
  }
}

// Listening for account changes
watchAccount(account => {
  address_user = account.address ?? '';
  if (account.isConnected) {
    btnE2.innerText = 'Desconectar';
    if (address_user != '') {
      const address = address_user.substring(0, 4) + "..." + address_user.substring(32, address_user.length);
      userEl.innerText = address;
    }
    readBalances();
    // Mostrar los elementos después de conectar
    updateVisibility(true);
  } else {
    btnE2.innerText = 'Conectar wallet';
    userEl.innerText = "";

    // Ocultar los elementos si no está conectado
    updateVisibility(false);
    cleanResults();
  }
});

// Redondea un número
const round = (n, dp) => {
  const h = +('1'.padEnd(dp + 1, '0'))
  return Math.round(n * h) / h
}

// Función para capitalizar la primera letra de una cadena
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}


function select_option(event) {
  const selectedValue = event.currentTarget.getAttribute('value');
  option = selectedValue;
}

function updateVisibility(isConnected) {
  const elements = document.querySelectorAll('.hidden');
  elements.forEach(el => {
    if (isConnected) {
      el.style.display = 'flex'; // Mantiene la disposición y hace visible el elemento
    } else {
      el.style.display = 'none'; // Mantiene la disposición pero oculta el elemento
    }
  });
}

// Lee los balances al conectarse la wallet
async function readBalances() {
  const { chain } = getNetwork();
  if (chain.id != 56) {
    await switchNetwork({ chainId: 56 });
  }

  // Mostrar bloque visible y ocultar bloque invisible
    visibleBlock.style.display = 'none';
    invisibleBlock.style.display = 'none';

    // Mostrar bloque visible y ocultar bloque invisible
    visibleBlock2.style.display = 'none';
    invisibleBlock2.style.display = 'none';
    invisibleBlock3.style.display = 'none';

  const hasToken = await readContract({
    address: smartContract,
    abi: wagmigotchiABI,
    functionName: '_hasNFT',
    args: [address_user]
  });

  // Verificar si el token ID ya voto
  const hasEndVotation = await readContract({
    address: smartContract,
    abi: wagmigotchiABI,
    functionName: 'votings',
    args: [votingId]
  });


  if (!hasToken) {

    // Mostrar bloque visible y ocultar bloque invisible
    visibleBlock.style.display = 'block';
    invisibleBlock.style.display = 'none';

    const valorBNB = await readContract({
      address: smartContract,
      abi: wagmigotchiABI,
      functionName: 'getLatestPriceBNB'
    });

    const priceToken = await readContract({
      address: smartContract,
      abi: wagmigotchiABI,
      functionName: 'nftPriceInUSD'
    });

    const valorPriceTokenInWei = BigInt(await readContract({
      address: smartContract,
      abi: wagmigotchiABI,
      functionName: 'convertToBNBWei',
      args: [priceToken]
    }));

    const amountInBNB = Number(valorPriceTokenInWei) / 1e18;

    bnb.innerHTML = "$" + valorBNB;
    tokenCost.innerHTML = "$" + priceToken;
    valueInBnb.innerHTML = round(amountInBNB, 8) + " BNB";

  } else {

    // Mostrar bloque invisible y ocultar bloque visible
    visibleBlock.style.display = 'none';
    invisibleBlock.style.display = 'block';
    visibleBlock2.style.display = 'block';

    // Verificar cual token posee
    const tokenNFTID = await readContract({
      address: smartContract,
      abi: wagmigotchiABI,
      functionName: 'getTokenIdByOwner',
      args: [address_user]
    });

    // Verificar si el token ID ya voto
    const hasVoted = await readContract({
      address: smartContract,
      abi: wagmigotchiABI,
      functionName: 'hasTokenVoted',
      args: [votingId, tokenNFTID]
    });

    if (hasVoted) {
      // Mostrar bloque invisible y ocultar bloque visible
      visibleBlock2.style.display = 'none';
      invisibleBlock2.style.display = 'block';
      invisibleBlock3.style.display = 'none';
    }else if(!hasVoted && hasEndVotation[2]){
      //visibleBlock2.style.display = 'block';
      invisibleBlock2.style.display = 'none';
      invisibleBlock3.style.display = 'none';
    } 

  }

  if (!hasEndVotation[2]) {
    // Mostrar bloque invisible y ocultar bloque visible
    visibleBlock2.style.display = 'none';
    invisibleBlock2.style.display = 'none';
    invisibleBlock3.style.display = 'block';
  }

  view_results();
}

async function buyVoto() {
  try {
    const balance = await readContract({
      address: smartContract,
      abi: wagmigotchiABI,
      functionName: 'checkBalance',
      args: [address_user]
    });

    //verifico balance bnb de la wallet del user
    /*const balance_bnb_user = await fetchBalance({
      address: address_user,
      formatUnits: 'ether'
    });*/


    // Verificar si el usuario ya posee un NFT
    const hasNFT = await readContract({
      address: smartContract,
      abi: wagmigotchiABI,
      functionName: '_hasNFT',
      args: [address_user]
    });

    if (hasNFT) {
      Swal.fire({
        icon: 'warning',
        title: 'Ya tienes un token Vote',
        background: '#191a1a',
        color: '#20f597'
      });
      readBalances();
      return;
    }

    const priceToken = await readContract({
      address: smartContract,
      abi: wagmigotchiABI,
      functionName: 'nftPriceInUSD'
    });

    const valorPriceTokenInWei = BigInt(await readContract({
      address: smartContract,
      abi: wagmigotchiABI,
      functionName: 'convertToBNBWei',
      args: [priceToken]
    }));

    // Verificar si el saldo es suficiente para cubrir el costo total
    if (balance < valorPriceTokenInWei) {
      Swal.fire({
        icon: 'error',
        title: 'Saldo insuficiente para la transacción',
        background: '#191a1a',
        color: '#20f597'
      });
      return;
    }

    // Realizar la transacción para acuñar el NFT
    const tx = await writeContract({
      address: smartContract,
      abi: wagmigotchiABI,
      functionName: 'mintNFT',
      args: [],
      value: valorPriceTokenInWei.toString() // Enviar el valor en Wei
    });

    const hash = tx.hash;
    Swal.fire({
      title: 'Comprando token!!!.',
      width: 600,
      padding: '3em',
      timerProgressBar: true,
      background: '#191a1a',
      color: '#20f597',
      backdrop: `
        rgb(0, 97, 46,0.9)
        url(`+ image_cat + `)
        left top
        no-repeat`
    })

    if (hash !== '') {
      await waitForTransaction({ hash })
        .then(result => {
          Swal.fire({
            icon: 'success',
            title: 'Token Vote comprado exitosamente!',
            width: 600,
            padding: '3em',
            background: '#191a1a',
            color: '#20f597'
          });
          readBalances();
        })
        .catch(error => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            background: '#191a1a',
            color: '#20f597',
            text: error.message
          });
        });
    }

  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      background: '#191a1a',
      color: '#20f597',
      text: error.message
    });
  }
}


async function vote() {
  try {

    // Verificar si el usuario ya posee un NFT
    const hasNFT = await readContract({
      address: smartContract,
      abi: wagmigotchiABI,
      functionName: '_hasNFT',
      args: [address_user]
    });

    if (!hasNFT) {
      Swal.fire({
        icon: 'warning',
        title: 'No tienes un token Vote para votar',
        background: '#191a1a',
        color: '#20f597'
      });
      return;
    }

    // Verificar si el usuario ya posee un NFT
    const tokenNFTID = await readContract({
      address: smartContract,
      abi: wagmigotchiABI,
      functionName: 'getTokenIdByOwner',
      args: [address_user]
    });

    // Verificar si el token ID ya voto
    const hasVoted = await readContract({
      address: smartContract,
      abi: wagmigotchiABI,
      functionName: 'hasTokenVoted',
      args: [votingId, tokenNFTID]
    });

    if (hasVoted) {
      Swal.fire({
        icon: 'warning',
        title: 'Ya has votado en estas elecciones',
        background: '#191a1a',
        color: '#20f597'
      });
      return;
    }


    if (option == undefined || option == null) {
      Swal.fire({
        icon: 'warning',
        title: 'Debes seleccionar una opción',
        background: '#191a1a',
        color: '#20f597'
      });
      return;
    }
    const tx = await writeContract({
      address: smartContract, // Dirección del contrato inteligente
      abi: wagmigotchiABI,    // ABI del contrato
      functionName: 'vote',   // Nombre de la función a llamar
      args: [votingId, tokenNFTID, option]
    });

    const hash = tx.hash;
    Swal.fire({
      title: 'Votando!!!.',
      width: 600,
      padding: '3em',
      timerProgressBar: true,
      background: '#191a1a',
      color: '#20f597',
      backdrop: `
        rgb(0, 97, 46,0.9)
        url(`+ image_cat + `)
        left top
        no-repeat`
    })

    if (hash !== '') {
      await waitForTransaction({ hash })
        .then(async result => {
          Swal.fire({
            icon: 'success',
            title: 'Voto efectuado correctamente!',
            width: 600,
            padding: '3em',
            background: '#191a1a',
            color: '#20f597'
          });
          await readBalances();
          await view_results();
        })
        .catch(error => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            background: '#191a1a',
            color: '#20f597',
            text: error.message
          });
        });
    }

  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      background: '#191a1a',
      color: '#20f597',
      text: error.message
    });
  }
}

async function view_results() {
  // Ver el resultado
  const results = await readContract({
    address: smartContract,
    abi: wagmigotchiABI,
    functionName: 'getVotingResult',
    args: [votingId]
  });

  const options = results[0];
  const votes = results[1];

  // Totalizar votos
  const totalVotes = votes.reduce((sum, vote) => sum + Number(vote), 0);

  // Crear el contenido de los resultados
  const resultHtml = options.map((option, index) => {
    const voteCount = Number(votes[index]);
    const percentage = totalVotes > 0 ? ((voteCount / totalVotes) * 100).toFixed(2) : 0;
    const color = index === 0 ? 'red' : 'blue'; // Asigna colores a las opciones

    // Crear el contenedor para la barra de progreso y el texto
    const resultItem = document.createElement('div');
    resultItem.classList.add('result-item');

    const optionName = document.createElement('span');
    optionName.classList.add('option-name');
    optionName.textContent = option;
    optionName.textContent = capitalizeFirstLetter(option); // Capitalizar la primera letra


    const progressBarContainer = document.createElement('div');
    progressBarContainer.classList.add('progress-bar-container');

    const progressBar = document.createElement('div');
    progressBar.classList.add('progress-bar');
    progressBar.style.width = `${percentage}%`;
    progressBar.style.backgroundColor = color;
    if(percentage >95){
      progressBar.style.borderRadius = '10px'; 
    }

    // Mostrar porcentaje dentro de la barra
    const percentageText = document.createElement('span');
    percentageText.classList.add('percentage-text');
    percentageText.textContent = `${percentage}%`;
    progressBar.appendChild(percentageText);

    progressBarContainer.appendChild(progressBar);

    // Crear y añadir el número de votos
    const votesInfo = document.createElement('span');
    votesInfo.classList.add('votes-info');
    votesInfo.textContent = ` ${voteCount} vote${voteCount > 1 ? 's' : ''}`;

    resultItem.appendChild(optionName);
    resultItem.appendChild(progressBarContainer);
    resultItem.appendChild(votesInfo);

    return resultItem;
  });

  // Limpiar resultados anteriores
  const resultadosContainer = document.getElementById('resultados');
  resultadosContainer.innerHTML = '';

  // Añadir nuevos resultados
  resultHtml.forEach(item => resultadosContainer.appendChild(item));
}

function cleanResults() {
  const resultadosContainer = document.getElementById('resultados');
  resultadosContainer.innerHTML = '';
}


document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.toggle-header');
  const content = document.querySelector('.content');

  header.addEventListener('click', function() {
      content.classList.toggle('show');
  });
});